import React,
{
    useEffect,
    useRef
}
from "react";

import * as am4core
    from "@amcharts/amcharts4/core";

import * as am4charts
    from "@amcharts/amcharts4/charts";

import am4themes_animated
    from "@amcharts/amcharts4/themes/animated";

import { LICENCE_KEY }
    from "../constants/charts";

am4core.useTheme(
    am4themes_animated
);

am4core.addLicense(
    LICENCE_KEY
);

export default function AmChartTreemap({
    chartId,
    width,
    height,
    chartData,
    valueColumn = "value",
    nameColumn = "name",
    childrenColumn = "children",
	selectedSpaceTypeId,
	onClick
})
{
	
    const chart =
        useRef(null);

    const colours =
    [
        "#6aaed6", // Desks
        "#6f7be3", // Breakout
        "#a16be0", // Meeting Rooms
        "#d46ad4", // Collaboration
        "#dd7698"  // Edit Suites
    ];
	
	const handleClick = (id) => {
		onClick(id);
	}

    function mapData(
        data,
        nameColumn,
        valueColumn,
        childrenColumn
    )
    {
        const returnValues = [];

        for(let i = 0; i < data.length; i++)
        {
            const item =
                data[i];

            const returnItem =
            {
				id:
				        item.id,
                name:
                    item[nameColumn],

                color:
                    am4core.color(
                        colours[i % colours.length]
                    )
            };

            let total = 0;

            const children = [];

            if(item[childrenColumn])
            {
                for(
                    let j = 0;
                    j < item[childrenColumn].length;
                    j++
                )
                {
                    const child =
                        item[childrenColumn][j];

                    const value =
                        child[valueColumn] || 1;

                    total += value;

                    children.push(
                    {
						id:
						        child.id,
                        name:
                            child[nameColumn],

                        value:
                            value,

                        color:
                            am4core.color(
                                colours[i % colours.length]
                            )
                    });
                }
            }

            returnItem.value =
                total;

            returnItem.children =
                children;

            returnValues.push(
                returnItem
            );
        }

        return returnValues;
    }
	
	
	useEffect(
	    function()
	    {
	        if(
	            !chart.current
	        )
	        {
	            return;
	        }

	        if(
	            selectedSpaceTypeId === null ||
	            selectedSpaceTypeId === -100
	        )
	        {
				if(
				    chart.current &&
				    chart.current.homeDataItem
				)
				{
				    chart.current.zoomToChartDataItem(
				        chart.current.homeDataItem
				    );
				}
	        }
	    },
	    [
	        selectedSpaceTypeId
	    ]
	);

    useEffect(() =>
    {
        const mappedData =
            mapData(
                chartData,
                nameColumn,
                valueColumn,
                childrenColumn
            );

        let x =
            am4core.create(
                chartId,
                am4charts.TreeMap
            );

        x.padding(
            0,
            0,
            0,
            0
        );

        x.data =
            mappedData;

        x.dataFields.value =
            "value";

        x.dataFields.name =
            "name";

        x.dataFields.children =
            "children";

        x.maxLevels =
            2;

        x.homeText =
            "Space Types";

        x.zoomable =
            true;

        x.hideParentColumns =
            false;

        x.colors.step =
            2;

        /*
         * LEVEL 0
         * Parent Categories
         */

        let level0 =
            x.seriesTemplates.create(
                "0"
            );

        level0.columns.template.propertyFields.fill =
            "color";

        level0.columns.template.fillOpacity =
            0.90;

        level0.columns.template.stroke =
            am4core.color(
                "#ffffff"
            );

        level0.columns.template.strokeWidth =
            2;

        level0.columns.template.tooltipText =
            "{name}: {value} sqm";

        let parentBullet =
            level0.bullets.push(
                new am4charts.LabelBullet()
            );

        parentBullet.locationX =
            0.5;

        parentBullet.locationY =
            0.5;

        parentBullet.label.text =
            "{name}";

        parentBullet.label.fill =
            am4core.color(
                "#ffffff"
            );

        parentBullet.label.fontSize =
            14;

        parentBullet.label.fontWeight =
            "bold";

        parentBullet.label.wrap =
            true;

        parentBullet.label.truncate =
            true;

        /*
         * LEVEL 1
         * Children
         */

        let level1 =
            x.seriesTemplates.create(
                "1"
            );
			
			level1.columns.template.events.on(
			    "hit",
			    function(ev)
			    {
			        if(!onClick)
			        {
			            return;
			        }

			        const dataItem =
			            ev.target.dataItem;

			        if(
			            !dataItem ||
			            !dataItem.dataContext
			        )
			        {
			            return;
			        }

			       
			        handleClick(dataItem.treeMapDataItem.dataContext.id);
			        
			    }
			);

        level1.columns.template.propertyFields.fill =
            "color";

        level1.columns.template.fillOpacity =
            0.65;

        level1.columns.template.stroke =
            am4core.color(
                "#000"
            );

        level1.columns.template.strokeWidth =
            1;
			
			level1.columns.template.strokeOpacity =
			            0.2;

        level1.columns.template.tooltipText =
            "{name}: {value} sqm";

        let childBullet =
            level1.bullets.push(
                new am4charts.LabelBullet()
            );

        childBullet.locationX =
            0.5;

        childBullet.locationY =
            0.5;

        childBullet.label.text =
            "{name}";

        childBullet.label.fill =
            am4core.color(
                "#ffffff"
            );

        childBullet.label.fontSize =
            10;

        childBullet.label.fillOpacity =
            0.85;

        childBullet.label.truncate =
            true;

        childBullet.label.hideOversized =
            true;

        chart.current =
            x;

        return () =>
        {
            x.dispose();
        };

    }, [
        chartId,
        chartData,
        valueColumn,
        nameColumn,
        childrenColumn
    ]);

    return (
        <div
            id={chartId}
            style={{
                width: width,
                height: height
            }}
        />
    );
}